import { defineMessages } from 'react-intl';
import { PICKUP_CONTACT, AVAILABLE_START_TIME, AVAILABLE_END_TIME } from './constants';

export default defineMessages({
  [PICKUP_CONTACT]: {
    defaultMessage: 'Contact is required',
    id: 'm3DY+Y',
    description: 'Pickup Settings Page, Contact Dropdown input is required label',
  },
  [AVAILABLE_START_TIME]: {
    defaultMessage: 'Start Time is required',
    id: 'mYUXg3',
    description: 'Pickup Settings Page, Start Time Dropdown input is required label',
  },
  [AVAILABLE_END_TIME]: {
    defaultMessage: 'End Time is required',
    id: 'NsfO9l',
    description: 'Pickup Settings Page, End Time Dropdown input is required label',
  },
  requireStartBeforeEndTime: {
    defaultMessage: 'Available Start Time must be before end time',
    id: 'z1r7Zv',
    description: 'Pickup Settings Page, Start Time Dropdown, is before end time input validation label',
  },
  requireEndAfterStartTime: {
    defaultMessage: 'Available End Time must be after start time',
    id: 'Rr/+9R',
    description: 'Pickup Settings Page, End Time Dropdown, is after start time input validation label',
  },
  requirePreferredTimeAfterStartTime: {
    defaultMessage: 'Must be after Available Start Time',
    id: 'bUfslQ',
    description: 'Pickup Settings Page, Preferred Time Dropdown, is after start time input validation label',
  },
  requirePreferredTimeBeforeEndTime: {
    defaultMessage: 'Must be before Available End Time',
    id: 'F7/r4V',
    description: 'Pickup Settings Page, Preferred Time Dropdown, is before end time input validation label',
  },
});
